(function($) {
    'use strict';

    /**
     * Плагин для реализации табов
     * @returns {jQuery}
     */
    $.fn.tabs = function () {
        const $self = $(this);
        const $tabs = $self.find('.js-tab-header');
        const $content = $self.find('.js-tab-content');

        /**
         * Выбор таба с указанным индексом
         * @param {Number} index - индекс таба
         */
        const selectTab = function (index) {
            $tabs.removeClass('active').eq(index).addClass('active');
            $content.removeClass('active').eq(index).addClass('active');

            if (typeof $tabs.eq(index).data('no-sidebar') !== 'undefined') {
                $content.parent().addClass('no-sidebar');
            } else {
                $content.parent().removeClass('no-sidebar');
            }

            // событие при переключении таба
            $self.trigger('tabchange', {
                index: index,
                tabElement: $tabs.eq(index),
                contentElement: $content.eq(index)
            });
        };

        /**
         * Инициализация
         */
        const init = function () {
            selectTab(0);

            // обработка событий
            $tabs.on('click', function() {
                selectTab($(this).index());
            });
        };

        init();

        // публичные методы
        this.selectTab = selectTab;

        return this;
    };
})(jQuery);
